/**
 * Date utility functions
 */

/**
 * Convert a Date object to datetime-local input format (YYYY-MM-DDTHH:mm)
 * WITHOUT timezone conversion (keeps local time)
 *
 * @param {Date} date - The date object to convert
 * @returns {string} - Formatted string for datetime-local input
 */
export const toLocalISOString = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

/**
 * Parse a datetime string from backend and convert to datetime-local format
 * Handles timezone conversion correctly
 *
 * @param {string} datetimeString - ISO datetime string from backend
 * @returns {string} - Formatted string for datetime-local input
 */
export const parseBackendDatetime = (datetimeString) => {
  if (!datetimeString) return '';
  const date = new Date(datetimeString);
  return toLocalISOString(date);
};
